import type { FieldValuesResponse, SaveFieldValueResponse } from "@repo/shared/types";
import { getWithToken, postWithToken } from "../_client";

const BASE = "/public/flow/field-values";

export function getPublicFieldValues(token: string) {
  return getWithToken<FieldValuesResponse>(BASE, token);
}

export function savePublicFieldValue(
  token: string,
  data: { fieldId: string; value: string; goalId?: string | null; portfolioId?: string | null },
) {
  return postWithToken<SaveFieldValueResponse>(BASE, token, data);
}
